import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function Laboratory() {
  return (
    <section className="laboratory">
      <Breadcrumbs />
      <h1>Лаборатория</h1>
    </section>
  );
}
